import AppChannel from "./model/AppChannel";
import CountryLabels from "./model/CountryLabels";
import PanelLayout from "./model/PanelLayout";

const channel = new AppChannel();
const countryLabels = new CountryLabels(channel);
const panelLayout = new PanelLayout(PanelLayout.FIT, PanelLayout.FIT);

export default {
  channel,
  countryLabels,
  panelLayout
};
